<template>
	<el-dialog
		:title="dialogTitle"
		:visible.sync="visible"
		v-loading="loadingDM"
		:append-to-body="true"
	>
		<slot name="alert">
			<el-alert class="mb-3" :title="alertInfo" type="error" :closable="false" v-if="alertInfo"></el-alert>
		</slot>

		<el-form
			ref="editorForm"
			:model="info"
			status-icon
			label-position="left"
			label-width="120px"
			size="mini"
			v-loading="loadings.main"
			v-if="hasGetTableDataModel && hasGetData"
			@submit.native.prevent
			:rules="rules"
		>
			<div class="row">
				<slot name="info"></slot>
				<div :class="key.col?'col-md-'+key.col:'col-md-12'" v-for="(key,index) in fields" :key="index">
					<el-form-item
						:label="dataModels[dataModelName][key.name].show_name"
						:prop="key.name"
						:error="errors[key.name]"
					>
						<field-show
							:record-model="dataModelName"
							:field-info="dataModels[dataModelName][key.name]"
							:value="info[key.name]"
							:field-key="key"
							:params="key.params"
							v-if="key.isOnlyShow"
						></field-show>
						<field-editor
							:width="key.width"
							:tips="key.tips"
							v-model="info[key.name]"
							@change="handleFormEdited"
							:field-info="dataModels[dataModelName][key.name]"
							:record-id="recordId"
							:record-model="dataModelName"
							:params="key.params"
							:ref="'key_'+key.name"
							v-else
						></field-editor>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<div slot="footer" class="dialog-footer" v-loading="loadings.formLoading">
			<el-button size="mini" @click="visible = false">取 消</el-button>
			<el-button size="mini" type="primary" @click="doConfirmEdit()" :disabled="!canSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";
import FieldShow from "@/components/FieldShow.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [LoadDM],
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false,
			},
			info: {},
			styles: [],
			visible: false,
			everEdited: false,
			rules: {},
			hasGetData: false,
			errors: {},
			canSubmit:true
		};
	},
	props: {
		isDialog: {
			type: Boolean,
			default: true,
		},
		dataModelName: {
			type: String,
			default: "",
		},
		recordId: {
			type: String,
			default: "",
		},
		isAutoFetch: {
			type: Boolean,
			default: true,
		},
		show: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: "name",
		},
		title: {
			type: String,
			default: "",
		},
		fields: {
			type: Array,
			default: function() {
				return [];
			},
		},
		watches: {
			type: Array,
			default() {
				return [];
			},
		},
		defaultValue: {
			type: Object,
			default() {
				return {};
			},
		},
		infoUrl: {
			type: String,
			default: "",
		},
		handlerUrl: {
			type: String,
			default: "",
		},
		checkEverEdited: {
			type: Boolean,
			default: true,
		},
		alertInfo: {
			type: String,
			default: "",
		},
	},
	mounted() {
		this.visible = this.show;
		this.resetErrors();
		if (this.show) {
			this.refreshData();
			this.setWatch();
		}
	},
	computed: {
		dialogTitle() {
			if (this.title != "") {
				return this.title;
			} else if (this.info[this.name]) {
				return this.info[this.name] + " : " + this.recordId;
			} else {
				return this.recordId;
			}
		},
	},
	methods: {
		handleFormEdited() {
			this.everEdited = true;
		},
		resetErrors() {
			this.fields.forEach(val => {
				this.$set(this.errors, val.name, "");
			});
		},
		handleSelect() {},
		_refreshRules() {
			for (let i = 0; i < this.fields.length; i++) {
				if (!this.fields[i].rules) {
					continue;
				}
				let real_rule = [];
				if (this.rules[this.fields[i].name]) {
					real_rule = this.rules[this.fields[i].name];
				}
				for (let j = 0; j < this.fields[i].rules.length; j++) {
					let rule = this.fields[i].rules[j];
					if (rule == "required") {
						if (
							this.dataModels[this.dataModelName][this.fields[i].name].type ==
							"Field_relate_simple_id"
						) {
							real_rule.push({
								required: true,
								message: "请输入",
								trigger: "change",
								type: "object",
								fields: {
									_id: { type: "string", required: true, message: "请选择" },
								},
							});
						} else if (
							this.dataModels[this.dataModelName][this.fields[i].name].type ==
							"Field_enum"
						) {
							real_rule.push({
								required: true,
								message: "请输入",
								trigger: "change",
								type: "object",
								fields: {
									index: { type: "number", min: 1, message: "请选择" },
								},
							});
						} else {
							real_rule.push({
								required: true,
								message: "请输入",
								trigger: "change",
							});
						}
					} else if (rule !== null && typeof rule === "object") {
						real_rule.push(rule);
					}
				}
				if (real_rule.length > 0) {
					this.$set(this.rules, this.fields[i].name, real_rule);
				}
			}
		},
		setWatch() {
			// [{ watch: "aField", to: "bField" }];
			this.watches.forEach(watch => {
				this.$watch("info." + watch.watch, function(newVal, oldVal) {
					if (this.$refs["key_" + watch.to].length > 0) {
						this.$refs["key_" + watch.to].forEach(val => {
							val.onWatchChange(watch.watch, newVal);
						});
					}
				});
			});
		},
		setData(data) {
			this.initInfo(data);
			this.hasGetData = true;
			this.canSubmit = true;
		},
		refreshData() {
			if (this.recordId == "") {
				this.initInfo();
				this.hasGetData = true;
				this.canSubmit = true;
				return;
			}
			if (!this.isAutoFetch) {
				return;
			}
			const url = this.infoUrl
				? `/${this.infoUrl}/${this.recordId}`
				: `/curd/edit/${this.dataModelName}/${this.recordId}`;
			this.loadings.main = true;
			this.$axios
				.post(url)
				.then(json => {
					this.loadings.main = false;
					this.initInfo(json.data.info);
					this.hasGetData = true;
					this.canSubmit = true;
				})
				.catch(json => {
					console.error(json);
					this.loadings.main = false;
				});
		},
		doConfirmEdit() {
			if (this.checkEverEdited && !this.everEdited) {
				this.$message.warning("数据无变化");
				return;
			}
			if (!this.canSubmit) {
				this.$message.warning("请勿连续提交");
				return;
			}
			this.canSubmit = false;

			this.resetErrors();
			this.$refs["editorForm"].validate(valid => {
				if (!valid) {
					this.canSubmit = true;
					return false;
				}

				const url = this.handlerUrl
					? `/${this.handlerUrl}/${this.recordId}`
					: `/curd/do_edit/${this.dataModelName}/${this.recordId}`;
				let posts = this.recordId ? { _id: this.recordId } : {};

				for (let k = 0; k < this.fields.length; k++) {
					if (this.fields[k].isOnlyShow) {
						continue;
					}
					if (this.info[this.fields[k].name] === undefined) {
						continue;
					}
					console.log(this.info[this.fields[k].name]);
					posts[this.fields[k].name] = JSON.parse(
						JSON.stringify(this.info[this.fields[k].name]),
					);
				}

				this.loadings.formLoading = true;
				this.$axios
					.post(url, posts)
					.then(json => {
						this.loadings.formLoading = false;
						console.log(this.fields);
						console.log(this.info.name);
						console.log(this.info);

						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$message.success("成功");
						this.visible = false;
						this.$emit("change", JSON.parse(JSON.stringify(this.info)));
						this.$refs["editorForm"].resetFields();

					})
					.catch(json => {
						this.loadings.formLoading = false;
						this.$message.error(json.data.msg);
						this.canSubmit = true;

						if (json.data.field) {
							this.errors[json.data.field] = json.data.msg;
						}
					});
			});
		},
	},
	components: {
		FieldEditor,
		FieldShow,
	},
	watch: {
		show: function(val) {
			this.visible = val;
			if (val) {
				this.refreshData();
			}
		},
		visible: function(val) {
			this.$emit("update:show", val);
		},
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					this._refreshRules();
					this.initInfo();
				}
			},
			immediate: true,
		},
	},
};
</script>